/* Header mobile drawer: full height slide in panel with focus management. */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-header-drawer]');
  var toggle = document.querySelector('[data-header-menu-toggle]');
  if (!drawer || !toggle) return;

  var closeButtons = drawer.querySelectorAll('[data-drawer-close]');
  var lastFocused = null;

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var firstLink = drawer.querySelector('a, button, summary');
    if (firstLink) firstLink.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  toggle.addEventListener('click', openDrawer);
  closeButtons.forEach(function (btn) { btn.addEventListener('click', closeDrawer); });
  drawer.addEventListener('click', function (event) {
    if (event.target.hasAttribute('data-drawer-overlay')) closeDrawer();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
})();
